<mat-dialog-content [ngClass]="{ar: translate.currentLang =='ar'}">
    <div class="form">
        <div class="closeHeader">
            <div class="row sec">
                <div class="col-6 col-md-4 col-lg-2 logo">
                    <img src="../../../assets/img/albaraq/TAZKRTI-dark 2.svg" alt="logo">
                </div> 
                <div class="col-6 col-md-8 col-lg-10 closeIcon">
                    <span class="" (click)="closeDialog()">X</span>
                </div> 
            </div>
        </div>
        <h2 class="title" (click)="closeDialog()">{{'password.forget' | translate}}</h2>
        <form [formGroup]="forgetPasswordForm" class="form-container" (ngSubmit)="onSubmit()">
            <div class="">
                <!-- Email -->
                <div class="col-12">
                    <mat-form-field color="accent" appearance="fill" class="authForm">
                        <!-- <fa-icon class="emailIcon" [icon]="faEnvelope"></fa-icon> -->
                    <input
                        matInput
                        required
                        id="email"
                        type="text"
                        formControlName="email"
                        placeholder="Enter your email"
                    />
                    </mat-form-field>
                                    <div *ngIf="forgetPasswordForm.get('email')?.invalid && forgetPasswordForm.get('email')?.touched" class="errorMsgForm">
                                        {{ getEmailErrorMessage(forgetPasswordForm.get('email')!, lang) }}
                                    </div>
                </div>
            </div>
        </form>
    </div>
        <div class="btns">
      <button mat-stroked-button (click)="closeDialog()">{{lang == 'en'? 'Cancel': 'الغاء'}}</button>
      <button mat-flat-button color="primary" (click)="onSubmit()" [disabled]="isLoading || forgetPasswordForm.invalid">
          <span *ngIf="!isLoading">{{lang == 'en'? 'Send': 'ارسال'}}</span>
          <mat-spinner
              *ngIf="isLoading"
              diameter="20"
              color="primary"
          ></mat-spinner>
      </button>
        </div>

</mat-dialog-content>